import { useContext } from 'react';
import { BackendRoutesControlContext } from '../../contexts/BackendRoutesControlContext';

const useControlRoutes = () => useContext(BackendRoutesControlContext);

export default useControlRoutes;
